
    // <auto-generated />

    import { AsyncResult } from '../async-result';
    import { DataServiceQuery } from '../DataServiceQuery';
    import { BusinessPartnerUser, AccountStatementRequest, BusinessPartnerOperationRequest } from '../Entities/CommerceTypes.g';
    import { IContext, IDataServiceRequest, IQueryResultSettings, NullResult } from '../Interfaces';
    import { executeAction } from '../retail-action';

    
    
    function businessPartnerUsersQuery(b2BUserId?: string): DataServiceQuery {
        var key = (b2BUserId) ? { B2BUserId: b2BUserId } : null;
        return new DataServiceQuery("BusinessPartnerUsers", "BusinessPartnerUser", "BusinessPartnerUserClass", key);
    }
    
    export function createCreateInput(entity: BusinessPartnerUser): IDataServiceRequest {
        return businessPartnerUsersQuery().create(entity);
    }

    export function createBusinessPartnerUserAsync(context: IContext, entity: BusinessPartnerUser): AsyncResult<BusinessPartnerUser> {
        const request = createCreateInput(entity);
        return executeAction<BusinessPartnerUser>(request, context);
    }

    export function createUpdateInput(entity: BusinessPartnerUser): IDataServiceRequest {
        return businessPartnerUsersQuery(entity.B2BUserId).update(entity);
    }

    export function updateAsync(context: IContext, entity: BusinessPartnerUser): AsyncResult<BusinessPartnerUser> {
        const request = createUpdateInput(entity);
        return executeAction<BusinessPartnerUser>(request, context);
    }

    export function createDeleteAsync(entity: BusinessPartnerUser): IDataServiceRequest {
        return businessPartnerUsersQuery(entity.B2BUserId).delete();
    }

    export function deleteAsync(context: IContext, entity: BusinessPartnerUser): AsyncResult<NullResult> {
        const request = createDeleteAsync(entity);
        return executeAction<NullResult>(request, context);
    }

    export function createReadAsync(b2BUserId: string): IDataServiceRequest {
        return businessPartnerUsersQuery(b2BUserId).read();
    }

    export function readAsync(context: IContext, b2BUserId: string): AsyncResult<BusinessPartnerUser> {
        const request = createReadAsync(b2BUserId);
        return executeAction<BusinessPartnerUser>(request, context);
    }

    export function createReadAllAsync(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
        return businessPartnerUsersQuery().resultSettings(queryResultSettings).read();
    }

    export function readAllAsync(context: IContext): AsyncResult<BusinessPartnerUser[]> {
        const request = createReadAllAsync(context.queryResultSettings);
        return executeAction<BusinessPartnerUser[]>(request, context);
    }
    
    export function createRequestAccountStatementInput(b2BUserId: string, accountStatementParameters?: AccountStatementRequest | null): IDataServiceRequest {      
        const query = businessPartnerUsersQuery(b2BUserId);
        return query.createDataServiceRequestForOperation('RequestAccountStatement', true, '', '', {bypassCache: 'get', returnEntity: ''}, {accountStatementParameters: accountStatementParameters });
    }    
    
    export function requestAccountStatementAsync(context: IContext, b2BUserId: string, accountStatementParameters?: AccountStatementRequest | null):AsyncResult<NullResult> {
        const request = createRequestAccountStatementInput(b2BUserId, accountStatementParameters);
        return executeAction<NullResult>(request, context);
    }          
          
    export function createRequestInvoiceCopyInput(b2BUserId: string, invoiceId: string | null, deliveryType: number, recipientEmail?: string | null): IDataServiceRequest {      
        const query = businessPartnerUsersQuery(b2BUserId);
        return query.createDataServiceRequestForOperation('RequestInvoiceCopy', true, '', '', {bypassCache: 'get', returnEntity: ''}, {invoiceId: invoiceId, deliveryType: deliveryType, recipientEmail: recipientEmail });
    }    
    
    export function requestInvoiceCopyAsync(context: IContext, b2BUserId: string, invoiceId: string | null, deliveryType: number, recipientEmail?: string | null):AsyncResult<NullResult> {
        const request = createRequestInvoiceCopyInput(b2BUserId, invoiceId, deliveryType, recipientEmail);
        return executeAction<NullResult>(request, context);
    }          
          
    export function createGetOperationRequestsInput(queryResultSettings: IQueryResultSettings, b2BUserId: string, startDateTime: Date, endDateTime: Date): IDataServiceRequest {      
        const query = businessPartnerUsersQuery(b2BUserId).resultSettings(queryResultSettings);
        return query.createDataServiceRequestForOperation('GetOperationRequests', true, 
             'BusinessPartnerOperationRequestClass'
          , 'true', {bypassCache: 'none', returnEntity: 'BusinessPartnerOperationRequest'}, {startDateTime: startDateTime, endDateTime: endDateTime });
    }    
    
    export function getOperationRequestsAsync(context: IContext, b2BUserId: string, startDateTime: Date, endDateTime: Date):AsyncResult<BusinessPartnerOperationRequest[]> {
        const request = createGetOperationRequestsInput(context.queryResultSettings, b2BUserId, startDateTime, endDateTime);
        return executeAction<BusinessPartnerOperationRequest[]>(request, context);
    }          
          
    export function createGetCurrentInput(): IDataServiceRequest {      
        const query = businessPartnerUsersQuery();
        return query.createDataServiceRequestForOperation('GetCurrent', false, 
             'BusinessPartnerUserClass'
          , 'false', {bypassCache: 'none', returnEntity: 'BusinessPartnerUser'}, { });
    }    
    
    export function getCurrentAsync(context: IContext, ):AsyncResult<BusinessPartnerUser> {
        const request = createGetCurrentInput();
        return executeAction<BusinessPartnerUser>(request, context);
    }          
          
    export function createGetAccessibleUsersInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {      
        const query = businessPartnerUsersQuery().resultSettings(queryResultSettings);
        return query.createDataServiceRequestForOperation('GetAccessibleUsers', false, 
             'BusinessPartnerUserClass'
          , 'true', {bypassCache: 'none', returnEntity: 'BusinessPartnerUser'}, { });
    }    
    
    export function getAccessibleUsersAsync(context: IContext, ):AsyncResult<BusinessPartnerUser[]> {
        const request = createGetAccessibleUsersInput(context.queryResultSettings, );
        return executeAction<BusinessPartnerUser[]>(request, context);
    }          
          
    